import React from "react";
import { Modal } from "react-bootstrap";
import { Trash } from "react-bootstrap-icons";
import { useTranslation } from "react-i18next";

import { DeleteProjectModalProps } from "./DeleteProjectModal.types.tsx";

import { GreenLabel, HeaderLabel, HelpLabel } from "../../components/Labels.tsx";
import { ActionButton } from "../../components/Buttons.tsx";

const DeleteProjectModal: React.FC<DeleteProjectModalProps> = ({
  show,
  handleClose,
  handleConfirm,
}) => {
  const { t } = useTranslation();

  return (
    <Modal show={show} onHide={handleClose} centered backdrop="static" keyboard={false}>
      <Modal.Body className="p-4 d-flex flex-column align-items-center text-center">
        <Trash className="mb-3" size={30} />

        <HeaderLabel>{t("deleteProjectModal.title")}</HeaderLabel>

        <HelpLabel>{t("deleteProjectModal.description")}</HelpLabel>

        <div className="d-flex justify-content-evenly w-100 mt-3 buttonsContainer">
          <GreenLabel margin="0" onClick={handleClose}>
            {t("deleteProjectModal.cancel")}
          </GreenLabel>

          <ActionButton width="30%" backgroundColor="#E20707" onClick={handleConfirm}>
            {t("deleteProjectModal.confirm")}
          </ActionButton>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default DeleteProjectModal;
